import { mapInfo } from "@69ly/maps";
import { useTranslation } from "react-i18next";
import { Link, Navigate } from "react-router";
import { Icon } from "../components/Icon.tsx";
import { ErrorState, Loading } from "../components/Status.tsx";
import { useCurrentTeam } from "../lib/current-team.tsx";
import { useMatches } from "../lib/demo-queries.ts";
import { errorText } from "../lib/errors.ts";
import { MapBar, useMapParam } from "./MapView.tsx";
import { MapGames } from "./Matches.tsx";

/** A map's Demos section in the library: the team's games on that map, each in its match. */
export function DemosPage() {
  const { t } = useTranslation();
  const map = useMapParam();
  const { team } = useCurrentTeam();
  const list = useMatches(team?.id ?? null);
  if (!map) return <Navigate to="/library" replace />;
  const games = (list.data ?? []).flatMap((m) => m.maps.filter((g) => g.map === map));
  const importLink = team ? (
    <Link to={`/demos/import?to=${team.id}&back=${encodeURIComponent(`/library/${map}/demos`)}`} className="btn btn-primary">
      <Icon name="upload" />
      {t("demos.importButton")}
    </Link>
  ) : null;
  return (
    <div className="library">
      <MapBar map={map} section="demos" count={team ? games.length : undefined} countLabel={t("demos.count", { count: games.length })} actions={importLink} />
      <div className="page">
        {!team ? (
          <div className="card learn-empty">
            <h1 className="section-title">{t("demos.title")}</h1>
            <p className="muted">{t("demos.teamOnly")}</p>
            <Link to="/team" className="btn btn-secondary">
              {t("demos.goTeam")}
            </Link>
          </div>
        ) : list.isPending ? (
          <Loading />
        ) : list.error ? (
          <ErrorState message={errorText(t, list.error)} onRetry={() => void list.refetch()} />
        ) : games.length === 0 ? (
          <div className="card learn-empty">
            <h1 className="section-title">{t("demos.emptyTitle", { map: mapInfo(map).name })}</h1>
            <p className="muted">{t("demos.emptyHelp")}</p>
            {importLink}
            <p className="muted small">
              <Link to="/matches?label=pro">{t("demos.seePro")}</Link>
            </p>
          </div>
        ) : (
          <>
            <p className="muted small">
              <Link to={`/matches?map=${map}`}>{t("matches.allOnMap", { map: mapInfo(map).name })}</Link>
            </p>
            <MapGames matches={list.data ?? []} map={map} />
          </>
        )}
      </div>
    </div>
  );
}
